import React from "react";
import { createRoot } from "react-dom/client";

import PersonagemApp from "./PersonagemApp.jsx";

const rootElement = document.getElementById("personagem-root");

if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <PersonagemApp />
    </React.StrictMode>
  );
}